import React, { useState, useEffect, useCallback } from 'react';
import { useInView } from 'react-intersection-observer';

const DELAYS = {
  0: 'delay-0',
  75: 'delay-75',
  100: 'delay-100',
  150: 'delay-150',
  200: 'delay-200',
  300: 'delay-300',
  400: 'delay-400',
  500: 'delay-500',
  600: 'delay-600',
  700: 'delay-700',
  800: 'delay-800',
  900: 'delay-900',
  1000: 'delay-1000',
  1100: 'delay-1100',
  1200: 'delay-1200',
  1300: 'delay-1300',
  1400: 'delay-1400',
  1500: 'delay-1500',
  1600: 'delay-1600',
  1700: 'delay-1700',
  1800: 'delay-1800',
  1900: 'delay-1900',
  2000: 'delay-2000'
};

const DURATION = {
  500: 'duration-500',
  700: 'duration-700',
  1000: 'duration-1000',
  1500: 'duration-1500'
};

const DIRECTION = {
  bottom: 'translate-y-1/3',
  top: '-translate-y-1/3',
  right: 'translate-x-1/4',
  left: '-translate-x-1/4'
};

const OPACITY = {
  0: 'opacity-0',
  10: 'opacity-10',
  15: 'opacity-15',
  20: 'opacity-20',
  25: 'opacity-25',
  30: 'opacity-30',
  40: 'opacity-40',
  50: 'opacity-50',
  75: 'opacity-75',
  100: 'opacity-100'
};

const VisibleLoading = ({
  delay = 100,
  duration = 700,
  direction = 'bottom',
  opacity = 100,
  disabled = false,
  threshold = 0,
  children
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold,
    ...(disabled ? { skip: true, initialInView: true } : {})
  });

  const className = inView
    ? `will-change-[opacity,transform] transition ease ${OPACITY[opacity] || 'opacity-100'} ${direction === 'bottom' || direction === 'top' ? 'translate-y-0' : 'translate-x-0'} ${DELAYS[delay] || ''} ${DURATION[duration] || ''}`
    : `will-change-auto transition ease opacity-0 ${DELAYS[delay] || 'delay-2000'} ${DURATION[duration] || 'duration-700'} ${DIRECTION[direction] || ''}`;

  return children({ ref, className, isVisible: inView });
};
export default VisibleLoading;
